<template>
  <div>
    <audio autoPlay playsInline ref="audioEl" />
  </div>
</template>

<script>
export default {
  name: "AudioTrack",
  props: ["track", "volume"],

  watch: {
    volume: {
      immediate: true,
      handler(volume) {
        this.$refs.audioEl.volume = volume;
      },
    },
  },

  mounted() {
    const audioEl = this.$refs.audioEl;
    audioEl.srcObject = new MediaStream([this.track]);
  },
};
</script>

<style scoped>
</style>
